import React from "react";

interface DashedLineProps {
    timeDiff?: string;
}

const DashedLine: React.FC<DashedLineProps> = ({ timeDiff }) => {
    const totalHeight = 179;
    const circleRadius = 12;
    const circlePosition = totalHeight / 2;
    const lineWidth = 2;
    const dashLength = 7;
    const dashGap = 6;
    const topTextMargin = 6;
    const bottomTextMargin = 2;
    const lineHeight = 15;
    const textOffset = 4;

    const timeDiffLines = timeDiff
        ? timeDiff.split(' ').reduce((pairs, word, i, arr) => {
            if (i % 2 === 0 && arr[i + 1]) {
                pairs.push(`${word} ${arr[i + 1]}`);
            }
            return pairs;
        }, [] as string[])
        : [];

    const textHeight = timeDiffLines.length * lineHeight;
    const totalContentHeight = textHeight + topTextMargin + bottomTextMargin;

    return (
        <div
            className="absolute left-1/2 transform -translate-x-1/2 h-full top-16"
            role="presentation"
        >
            <svg width={circleRadius * 2 + lineWidth} height={totalHeight} className="overflow-visible">
                <line
                    x1={circleRadius + lineWidth / 2}
                    y1="0"
                    x2={circleRadius + lineWidth / 2}
                    y2={circlePosition - totalContentHeight / 2}
                    stroke="#041A3C"
                    strokeWidth={lineWidth}
                    strokeDasharray={`${dashLength} ${dashGap}`}
                />
                <line
                    x1={circleRadius + lineWidth / 2}
                    y1={circlePosition + totalContentHeight / 2}
                    x2={circleRadius + lineWidth / 2}
                    y2={totalHeight}
                    stroke="#041A3C"
                    strokeWidth={lineWidth}
                    strokeDasharray={`${dashLength} ${dashGap}`}
                />
                {timeDiff && (
                    <text fill="#041A3C" fontSize="12" fontWeight="bold">
                        {timeDiffLines.map((part, i) => (
                            <tspan
                                key={i}
                                x={circleRadius + lineWidth / 2}
                                y={circlePosition - textHeight / 2 + i * lineHeight + textOffset}
                                textAnchor="middle"
                                dominantBaseline="central"
                            >
                                {part}
                            </tspan>
                        ))}
                    </text>
                )}
            </svg>
        </div>
    );
};

export default DashedLine;
